import { Text as BaseText, View } from 'react-native';
import styled from 'styled-components/native';

import colors from './colors';
import fonts from './fonts';

export const Text = styled(BaseText)`
  font-family: '${fonts.body}';
  font-size: 16px;
`;

export const Title = styled(Text)`
  font-size: 24px;
`;

export const Subtitle = styled(Text)`
  font-size: 20px;
  font-weight: 600;
  margin-vertical: 12px;
`;

export const Hint = styled(BaseText)`
  font-size: 14px;
  font-style: italic;
`;

export const Setting = styled(View)`
  flex-direction: row;
  gap: 10px;
  margin-bottom: 5px;
`;

export const SettingLabel = styled(Text)`
  min-width: 200px;
`;
